import gql from 'graphql-tag';

export default gql`
  query {
    courses(filter: { alive_course: COURSE_ALIVE }, sort: INDEX_ASC) {
      _id
      name
      description
      photo
      index
      status
      courseItems {
        _id
        index
        subject {
          _id
          name
          description
          photo
          status
          alive_subject
          teacher {
            _id
            firstname
            lastname
            avatar
          }
          contents {
            _id
            name
            type
            viewCount
            public
            contentGroup {
              _id
              name
            }
          }
        }
      }
    }
  }
`;
